import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DemandService } from '../../../_services/demand.service';
import { CompanyService } from '../../../_services/company.service';
import { PlaceService } from '../../../_services/place.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { DateService } from '../../../_services/date.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-edit-demand',
  templateUrl: './edit-demand.component.html',
  styleUrls: ['./edit-demand.component.css']
})
export class EditDemandComponent implements OnInit {

  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_demand: boolean;
  private demand_id: number;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    openSelectorOnInputClick: true,
    editableDateField: false
  };

  constructor(private service: DemandService, private company_service: CompanyService, private place_service: PlaceService, private date_service: DateService) { }

  edit_demand = new FormGroup({
    client_id: new FormControl('', [Validators.required]),
    receiver_id: new FormControl(''),
    departure_id: new FormControl('', [Validators.required]),
    arrival_id: new FormControl('', [Validators.required]),
    vehicle: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required]),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    sell_price: new FormControl(),
    note: new FormControl()
  });

  ngOnInit() {

  }

  openModal(demand) {
    this.demand_id = demand.id;
    jQuery('#edit-demand-modal .dropdown').dropdown('restore defaults'); // Clear the Select
    this.edit_demand.patchValue(demand);

    if (demand.departure_date) {
      this.edit_demand.patchValue({
        departure_date: {
          formatted: this.date_service.myDateFormatted(demand.departure_date)
        }
      })
    }

    if (demand.arrival_date) {
      this.edit_demand.patchValue({
        arrival_date: {
          formatted: this.date_service.myDateFormatted(demand.arrival_date)
        }
      })
    }

    jQuery('#edit-demand-modal').modal({ inverted: true }).modal('show');

  }

  submitDemandForm() {
    this.edit_demand.disable();
    this.updating_demand = true; // Disable the loading button apparition
    if (this.edit_demand.value.client_id instanceof Object) this.edit_demand.patchValue({ client_id: this.edit_demand.value.client.id }); // Avoid seller being an object
    if (this.edit_demand.value.departure_id instanceof Object) this.edit_demand.patchValue({ departure_id: this.edit_demand.value.departure.id }); // Avoid seller being an object
    if (this.edit_demand.value.arrival_id instanceof Object) this.edit_demand.patchValue({ arrival_id: this.edit_demand.value.arrival.id }); // Avoid seller being an object
    // Set Dates values correctly
    if (this.edit_demand.value.departure_date && this.edit_demand.value.departure_date.formatted) this.edit_demand.patchValue({ departure_date: this.edit_demand.value.departure_date.formatted });
    if (this.edit_demand.value.arrival_date && this.edit_demand.value.arrival_date.formatted) this.edit_demand.patchValue({ arrival_date: this.edit_demand.value.arrival_date.formatted });
    this.service.updateDemand(this.demand_id, this.edit_demand.value)
      .subscribe(response => {
        this.updating_demand = false; // Disable the loading button apparition
        this.edit_demand.enable(); // Re Enable the Form
        this.edit_demand.reset(); // Reset It
        this.demand_id = undefined;
        this.refresh.emit(true); // Emmit the refresh Event
        jQuery('#edit-demand-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/demand/edit-demand/edit-demand.component.ts